var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.service)?[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.serviceedition.title', _vm.service)))]),_vm._v(" "),_c('v-card-text',[_c('service-form',{attrs:{"service":_vm.service}})],1)]:_c('v-progress-linear',{attrs:{"indeterminate":true,"height":"2"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196e789c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ServiceEdition.vue
// module id = null
// module chunks = 